module.exports = __webpack_public_path__ + "static/media/munch8.39c56dbe.wav";